var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebtCollection = function SvgDebtCollection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#026BFF",
    d: "M3.8 5.3 2.4 6.7l2.7 2.7 4.7-4.7-1.4-1.4-3.3 3.3zM20 3h-7.9v2H20zM18 6h-5.9v2H18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#026BFF",
    d: "M10.1 0H.1v10h2V2h8zM3.8 17.3l-1.4 1.4 2.7 2.7 4.7-4.7-1.4-1.4-3.3 3.3zM20 15h-7.9v2H20zM18 18h-5.9v2H18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#026BFF",
    d: "M.1 22h2v-8h8v-2H.1z"
  })));
};
export default SvgDebtCollection;